<template>
  <div class="row m-0">
    <delete-trustee-popup :trustee="trusteeDelete" v-if="isDelete" @close="close"></delete-trustee-popup>
    <div class="col-12 mb-3 px-0 pb-3 border-bottom">
      <div class="row m-0 align-items-center">
        <div class="col p-0">
          <h4 class="mb-0">Trustees</h4>
        </div>
        <div class="col-auto p-0 text-end">
          <button class="btn btn-primary px-2 px-md-3 px-lg-5" @click="addTrustee">
            <div class="row m-0 align-items-center">
              <div class="col-auto p-0 d-flex">
                <ios-add-icon />
              </div>
              <div class="col ps-1">
                Add <span class="d-none d-md-inline-flex">Trustee</span>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 p-3 p-md-4">
      <div class="row mx-0 justify-content-center">
        <div class="col-11 col-md-8 col-lg-7 col-xl-6 p-0">
          Trustees will notify Remember Blue in the event something were to happen to you. This is an important role and should only be given to people you trust. Remember to keep your trustee information is up to date.
        </div>
      </div>
    </div>
    <div class="col-12 p-3 p-md-4 white_bg">
      <div class="row m-0" v-if="Object.keys(trusteesWithDetails).length === 0" >
        <div class="col-12 p-0">
          No trustees. Please <span @click="addTrustee" class="link_colour cursor">add</span> some.
        </div>
      </div>
      <div class="row m-0" v-else>
        <div class="col-12 p-0">
          <div class="row m-0 py-2 mb-2 border-bottom align-items-center" v-for="(trustee, key) in trusteesWithDetails" :key="trustee.email">
            <div class="col-6 col-md-9 p-0">
              <div class="row m-0">
                <div class="col-12 p-0 bold">
                  {{trustee.firstname}} {{trustee.lastname}}
                </div>
                <div class="col-12 p-0 smallfont">
                  {{trustee.email}}
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3 p-0 text-end">
              <div class="row m-0 justify-content-end">
                <div class="col-auto col-md-auto pe-0 small">
                  <button v-if="trustee.denied" type="button" class="btn btn-sm btn-outline-danger" disabled>Denied</button>
                  <button v-else-if="typeof trustee.confirmed === 'undefined'" type="button" class="btn btn-sm btn-outline-warning" disabled>Pending</button>
                  <button v-else type="button" class="btn btn-sm btn-outline-success" disabled>Confirmed</button>
                </div>
                <div class="col-auto col-md-auto pe-0 small cursor" @click="remove(key)">
                  <div class="row m-0 h-100 align-items-center">
                    <div class="col-12 p-0">
                      <ios-trash-icon />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Trustees',
  components: {
    'delete-trustee-popup': () => import('../components/DeleteTrusteePopup.vue')
  },
  data () {
    return {
      isDelete: false,
      trusteeDelete: {}
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'contacts', 'trustees']),
    trusteesWithDetails () {
      return this.trustees
    }
  },
  methods: {
    ...mapActions(['deleteTrustee']),
    addTrustee () {
      this.$router.push('addtrustee')
    },
    remove (id) {
      this.trusteeDelete = this.trustees[id]
      this.trusteeDelete.id = id
      this.isDelete = true
      // console.log(val)
      // this.deleteTrustee(val)
    },
    close () {
      this.isDelete = false
      this.trusteeDelete = {}
    }
  }
}
</script>

<style scoped>
</style>
